import React from "react";
import SEO from "@/components/SEO";
import LocationTemplate from "@/components/LocationTemplate";

const StrathmorePage = () => <LocationTemplate suburbName="Strathmore" suburbSlug="strathmore" />;

export default StrathmorePage;
